import posthog from 'posthog-js'

import type { UserModule } from '@/types'

// Install and configuration Posthog: https://posthog.com/docs/libraries/vue-js#method-2-use-provide--inject
export const install: UserModule = (app, router) => {
  if (!import.meta.env.PROD || !import.meta.env.VITE_APP_POSTHOG_TOKEN) {
    return
  }

  posthog.init(import.meta.env.VITE_APP_POSTHOG_TOKEN, {
    api_host: 'https://ph.swipe4work.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    disable_session_recording:
      import.meta.env.VITE_APP_POSTHOG_SESSION_RECORDING !== 'true',
  })
  app.provide('posthog', posthog)

  // Manually capture pageviews
  router.afterEach((to, _from, failure) => {
    if (!failure) {
      nextTick(() => {
        posthog.capture('$pageview', { path: to.fullPath })
      })
    }
  })
}
